// @ts-nocheck — mixin methods are composed onto BackendService at runtime; instance API is typed via adminBackendServiceInterface.d.ts.
import type BaseBackendService from '../BaseBackendService';
import { DeleteCategoryResult, DocumentCategory } from '../../models/DocumentCategory';

export const adminBackendServiceDocumentCategoryMixin = {
  listDocumentCategories(): Promise<DocumentCategory[]> {
    return this.authApiGetAuthed(
      'admin/documentCategories',
      'Network error while loading document categories',
      (json) => (json?.data ?? []) as DocumentCategory[],
    );
  },

  createDocumentCategory(body: { name: string }): Promise<DocumentCategory> {
    return this.authApiMutateAuthed(
      'admin/documentCategories',
      'POST',
      body,
      (json) => json?.data as DocumentCategory,
    );
  },

  updateDocumentCategory(
    id: string,
    body: { name?: string; isDefault?: boolean },
  ): Promise<DocumentCategory> {
    return this.authApiMutateAuthed(
      `admin/documentCategories/${id}`,
      'PATCH',
      body,
      (json) => json?.data as DocumentCategory,
    );
  },

  // Deliberately does its own fetch: authApiMutateAuthed funnels non-2xx bodies
  // through parseStructuredError, whose default branch drops requiresMerge /
  // documentCount that the 409 response carries.
  deleteDocumentCategory(id: string, mergeIntoCategoryId?: string): Promise<DeleteCategoryResult> {
    return this.authFetchPromise(async (token: string | null) => {
      const response = await this.authenticatedFetch(
        this.apiURL(`admin/documentCategories/${id}`),
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(mergeIntoCategoryId ? { mergeIntoCategoryId } : {}),
        },
      );

      if (response.status === 204) {
        return { ok: true } as DeleteCategoryResult;
      }

      const data = await response.json().catch(() => ({}));
      if (response.status === 409 && data?.requiresMerge) {
        return {
          requiresMerge: true,
          documentCount: data.documentCount ?? 0,
        } as DeleteCategoryResult;
      }
      throw new Error(data?.message || data?.error || `Error: ${response.status}`);
    });
  },
} satisfies ThisType<BaseBackendService>;
